import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import withActiveVehicle from 'components/common/hoc/withActiveVehicle'
import getSearchByVehicleUrl from 'helpers/getSearchByVehicleUrl'
import { getGTMData } from './helpers'
import { googleAnalyticProductImpressions, googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getActiveVehicle } from 'selectors'
import RecommendedProductsComponent from './RecommendedProducts'


const mapStateToProps = state => ({
  searchByVehicleUrl: getSearchByVehicleUrl(getActiveVehicle(state))
})

const withSendStatisticOnDidMount = lifecycle({
  componentDidMount() {
    this.props.googleAnalyticProductImpressions({ data: getGTMData(this.props.gBBDetails) })
  }
})

export const RecommendedProducts = compose(
  withType({ type: 'RecommendedProducts' }),
  connect(mapStateToProps, { googleAnalyticProductImpressions, googleAnalyticProductClicks }),
  withSendStatisticOnDidMount,
  withActiveVehicle
)(RecommendedProductsComponent)
